// eslint-disable-next-line import/prefer-default-export
export const favoriteLinksMap = {
  accountTeam: 'Account team',
  approvalManagement: 'Approval management',
  customerDocs: 'Customer documents',
  dashboard: 'Dashboard',
  demoStandards: 'Company standards',
  demoStandardsNew: 'Company standards',
  hld: 'Hosted licensing dashboard',
  inventoryReports: 'Inventory reports',
  invoiceHistory: 'Invoice history',
  licenseAdvisor: 'Enterprise license dashboard',
  manageCloud: 'Manage cloud',
  manageStandards: 'Manage standards',
  manageStandardsNew: 'Manage standards',
  myCompany: 'My company',
  myStandards: 'Company standards',
  'Company Standards': 'Company standards',
  myStandardsNew: 'Company standards',
  orderTracking: 'Order tracking/history',
  personalProductList: 'Personal product list',
  productCompare: 'Product compare',
  quoteHistory: 'Quote history',
  renewalManager: 'Renewals & warranty manager',
  reports: 'Reporting management',
  requisitionHistory: 'Requisition history',
  rma: 'RMA request',
  roles: 'Roles',
  savedCarts: 'Saved carts / order templates',
  softwareContracts: 'My software license agreements',
  softwareReports: 'Software summary reports',
  standardReports: 'Standard reports',
  userManagement: 'User management',
  userProfile: 'User profile',
  userSubscriptions: 'User subscriptions',
}
